// src/features/nameDescription/nameDescriptionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  description: '',
  rolesDetailsData:[]
};

const nameDescriptionSlice = createSlice({
  name: 'nameDescription',
  initialState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    clearFields: (state) => {
      state.name = '';
      state.description = '';
    },
    // rolesDetailsDataFunc: (state, action) => {
    //   state.rolesDetailsData = action.payload;
    // },
  },
});

export const { setName, setDescription, clearFields } = nameDescriptionSlice.actions;

export default nameDescriptionSlice.reducer;
